import React from "react"
import { twMerge } from "tailwind-merge"
import Stars from "./Stars"
import { formatNumber } from "../utils/productUtils"

/**
 * Rating stars + count. variant: default (light) | hero (white text on dark)
 */
export default function ProductRating({
  avgRating,
  numRatings,
  onClick,
  variant = "default",
  hideRatingNumber = false,
  className = "",
}) {
  if (avgRating === undefined || avgRating === null) return null
  const hero = variant === "hero"
  return (
    <span
      onClick={onClick}
      className={twMerge(
        "inline-flex items-center gap-1",
        onClick && "cursor-pointer hover:opacity-80",
        hero ? "text-white" : "text-text",
        className
      )}
    >
      {!hideRatingNumber && 
        <span className="text-sm font-medium">  
          {avgRating.toFixed(1)}
        </span>
      }
      <Stars 
        value={avgRating}
        size={14} 
        className={hero ? "text-white" : ""} 
      />
      <span className={twMerge("text-xs", hero ? "text-white/80" : "text-text_secondary")}>
        {formatNumber(numRatings)}
      </span>
    </span>
  )
}
